import moment from "moment";

//Objeto de campo padronizado para envio a função validarCampos
export const objCampo = ({ name, required, number, email, cnpj, cpf, cpfcnpj, date, birthDate, placa }) => {
    return { name, required, number, email, cnpj, cpf, cpfcnpj, date, birthDate, placa };
}
export const validarCampos = (obj, campos) => {
    const objetoDeErros = {};

    const emailRegex = /\S+@\S+/;
    const placaRegex = /^[A-Za-z]{3}[0-9][0-9A-Za-z][0-9]{2}$/;

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    const erros = campos.filter(campo => {
        const valor = getNestedValue(obj, campo.name);

        if (!valor || campo.required && (
            valor === "" || 
            valor?.length === 0 || 
            (typeof valor === 'object' && Object.keys(valor).length === 0)
        )) {
            objetoDeErros[campo.name] = { message: "" };
            return campo;
        }

        if (campo.number && isNaN(valor.toString().replace(',', '.'))) {
            objetoDeErros[campo.name] = { message: "* O valor não é numérico" };
            return campo;
        } else if (campo.number && parseFloat(valor.toString().replace(',', '.')) === 0.00) {
            objetoDeErros[campo.name] = { message: "" };
            return campo;
        }

        if (campo.email && !emailRegex.test(valor)) {
            objetoDeErros[campo.name] = { message: "* E-mail inválido" };
            return campo;
        }

        if (campo.placa) {
            const num = valor.replace(/[^0-9a-zA-Z]/g, '');
            if (!placaRegex.test(num)) {
                objetoDeErros[campo.name] = { message: "* Placa inválida" };
                return campo;
            }
        }

        if (campo.cnpj && !isValidCNPJ(valor)) {
            objetoDeErros[campo.name] = { message: "* CNPJ inválido" };
            return campo;
        }

        if (campo.cpf && !isValidCPF(valor)) {
            objetoDeErros[campo.name] = { message: "* CPF inválido" };
            return campo;
        }

        if (campo.cpfcnpj) {
            const num = valor.toString().replace(/[^A-Za-z0-9]/g, '');
            const hasLetters = /[A-Za-z]/.test(num);
            if (num.length <= 11 && !hasLetters) {
                if (!isValidCPF(valor)) {
                    objetoDeErros[campo.name] = { message: "* CPF inválido" };
                    return campo;
                }
            } else if (!isValidCNPJ(valor)) {
                objetoDeErros[campo.name] = { message: "* CNPJ inválido" };
                return campo;
            }
        }

        if (campo.date && !isValidDate(valor)) {
            objetoDeErros[campo.name] = { message: "* Data inválida" };
            return campo;
        }

        if (campo.birthDate && !isValidDataNascimento(valor)) {
            objetoDeErros[campo.name] = { message: "* Data inválida" };
            return campo;
        }
    });

    return [objetoDeErros, erros];
};


// Função para mostrar o resultado do erro para determinado campo
export const PrintValidate = ({ errors, field }) => {
    return (
        <span className="mb-4">
            {errors[field] && <span className={"form-control-label text-danger"}>{errors[field].message}</span>}
        </span>
    )
}

// Função que valida se o documento é um CPF (11 dígitos) ou CNPJ (14 dígitos) válido
export function isValidCpfCnpj(value) {
    const num = (value ?? "").toString().replace(/[^A-Za-z0-9]/g, '');
    return num.length === 11 ? isValidCPF(num) : isValidCNPJ(num);
}

//Função de validação de cnpj
function isValidCNPJ(value) {

    if (!value) return false;

    // Elimina CNPJs invalidos conhecidos
    if (value === "00000000000000" ||
        value === "11111111111111" ||
        value === "22222222222222" ||
        value === "33333333333333" ||
        value === "44444444444444" ||
        value === "55555555555555" ||
        value === "66666666666666" ||
        value === "77777777777777" ||
        value === "88888888888888" ||
        value === "99999999999999")
        return false;

    value = value.toString().replace(/[^A-Za-z0-9]+/g, '').toUpperCase();

    if (value.length !== 14) return false;

    // Elimina inválidos com todos os caracteres iguais
    if (/^(.)\1+$/.test(value)) return false;

    // Apenas os 12 primeiros podem ser letras, os 2 últimos devem ser números
    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(value)) return false;

    const calc = (x) => {
        let factor = x - 7;
        let sum = 0;

        for (let i = 0; i < x; i++) {
            const n = value.charCodeAt(i) - 48;
            sum += n * factor--;
            if (factor < 2) factor = 9;
        }

        const result = 11 - (sum % 11);
        return result > 9 ? 0 : result;
    };

    const digit0 = calc(12);
    if (digit0 !== parseInt(value.charAt(12))) return false;

    const digit1 = calc(13);
    return digit1 === parseInt(value.charAt(13));
}

function isValidCPF(cpf) {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '')

    if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
    )
        return false

    let soma = 0
    let resto
    for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11)) resto = 0
    if (resto !== parseInt(cpf.substring(9, 10))) return false
    soma = 0
    for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11)) resto = 0
    if (resto !== parseInt(cpf.substring(10, 11))) return false
    return true
}

//Função de validação de data
function isValidDate(input_date) {
    if (!moment(input_date, "YYYY-MM-DD", true).isValid())
        return false;
    else {
        var minDate = moment.utc("1900-01-01");
        if (moment(input_date, "YYYY-MM-DD", true).isAfter(minDate))
            return true;
        else
            return false;
    }
}

//Função de validação de data de nascimento
function isValidDataNascimento(input_date) {
    if (!isValidDate(input_date))
        return false;
    else {
        var current_date = moment(new Date()).format("YYYY-MM-DD");
        var date = moment(input_date, "YYYY-MM-DD", true);

        if (date.diff(current_date, 'days') > 0)
            return false;
        else
            return true;
    }
}

// Função que valida o período máximo entre duas datas
export function isDateOverflow(start_date, end_date, period, unit = 'days') {
    if (unit === 'months') {
        return moment(end_date).isAfter(moment(start_date).add(period, 'months'))
    }

    const startDate = new Date(start_date)
    const endDate = new Date(end_date)

    const timeDiff = Math.abs(endDate - startDate)
    const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

    if (dayDiff > period) 
        return true
    else
        return false
}